import React from "react";
import moment from "moment";
import { UserAvatar } from "../../components/Atoms/Avatar";
import { formatWrittenDateTimeUtc } from "../../utilities";
interface Props {
  item: server.dto.DocumentChecklistItem
  reset: () => void
}

const ChecklistDeclinedRowCard = (props: Props) => {
  const { item } = props;

  const checkedUtcMoment = moment.utc(item.checkedUtc);

  return <div className="lightred-bg">
    <div className="grow1">
      <div className="flex">
        <div className="margin-right">
          <UserAvatar user={item.checkedUser} />
        </div>

        <div className="grow1">
          <div><h3>{item.question}</h3></div>
          <div className="margin-top-small" title={formatWrittenDateTimeUtc(checkedUtcMoment)}>{RESX.Checklist.DeclinedBy} {item.checkedUser.fullName} {checkedUtcMoment.fromNow()}</div>
        </div>

        <div>
          <i className="icon-x red" style={{ fontSize: 23 }} onClick={props.reset} />
        </div>
      </div>

      {item.declinedReason && <div className="margin-top-small padding-large lightred-bg s1_small">
        {item.declinedReason}
      </div>}
    </div>
  </div>;
};

export default ChecklistDeclinedRowCard;